<script>
import moment from 'moment-timezone'
import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/auth'
import 'firebase/firestore'
import router from '@/router'
import { getSessionCachedData } from '@/utils/sessionDataCache'

const axios = require('axios').default

const ACTIVE_STATUS = 'Y'
const ENTERTAINMENT_ENDPOINT = 'https://asia-east2-fun-beyond.cloudfunctions.net/getEntertainment'
const ENTERTAINMENT_API_KEY = 'LosnQ8W6uWoVs8N-ik_'
const ENTERTAINMENT_MENU_KEYS = ['movie', 'series', 'seriesjeen', 'sports', 'cartoon', 'sex18', 'aihackslot']
const ENTERTAINMENT_LINK_MENU_MAP = [
  { menu: 'seriesjeen', keywords: ['seriesjeen'] },
  { menu: 'series', keywords: ['seriesfunny'] },
  { menu: 'movie', keywords: ['warpnung'] },
  { menu: 'sports', keywords: ['ballxlive'] },
  { menu: 'cartoon', keywords: ['ducartoon'] },
  { menu: 'sex18', keywords: ['sex18', 'keekub', 'seawjung'] },
  { menu: 'aihackslot', keywords: ['aihackslot', 'aihackcasino'] }
]
const ENTERTAINMENT_DOMAIN_REPLACEMENTS = {
  '{warpnung}': 'warpnung.com',
  '{seriesfunny}': 'seriesfunny.com',
  '{ballxlive}': 'ballxlive.com',
  '{ducartoon}': 'ducartoon.com',
  '{seriesjeen}': 'seriesjeen.com'
}

function textValue (value) {
  if (value === undefined || value === null) return ''
  return String(value)
}

function trimValue (value) {
  return textValue(value).trim()
}

function numberValue (value, fallback) {
  const parsed = Number(value)
  return isNaN(parsed) ? fallback : parsed
}

function amountValue (value, fallback) {
  const parsed = Number(textValue(value).replace(/,/g, ''))
  return isNaN(parsed) || parsed < 0 ? fallback : parsed
}

function formatAmount (value) {
  return amountValue(value, 0).toLocaleString('th-TH', {
    maximumFractionDigits: 2
  })
}

function normaliseDepositCondition (value) {
  const source = value || {}
  const minimum = amountValue(
    source.minimumCurrentMonthDeposit,
    amountValue(source.minimumPreviousMonthDeposit, 0)
  )

  return {
    enabled: source.enabled === true,
    minimumCurrentMonthDeposit: minimum,
    minimumPreviousMonthDeposit: minimum
  }
}

export default {
  name: 'SpeedDialFab',
  data () {
    return {
      activeMainKey: '',
      fabMenuItems: [],
      currentMonthDeposit: 0,
      statusFilter: ACTIVE_STATUS
    }
  },
  computed: {
    activeMain () {
      return this.fabMenuItems.find(menu => menu.key === this.activeMainKey) || null
    }
  },
  mounted () {
    this.fetchFabMenu()
  },
  methods: {
    toggleMainMenu (menu) {
      if (this.activeMainKey === menu.key) {
        this.closeMenu()
        return
      }

      if (!this.canAccessMainMenu(menu)) {
        this.showDepositWarning(menu)
        return
      }

      if (!menu.submenus.length && menu.link) {
        this.openLink(menu, menu)
        return
      }

      this.activeMainKey = menu.key
    },
    closeMenu () {
      this.activeMainKey = ''
    },
    openSubmenu (submenu) {
      if (this.openLink(submenu, this.activeMain)) {
        this.closeMenu()
      }
    },
    openLink (item, mainMenu) {
      if (mainMenu && !this.canAccessMainMenu(mainMenu)) {
        this.showDepositWarning(mainMenu)
        return false
      }

      const entertainmentMenuKey = this.resolveEntertainmentMenuKey(item)
      if (entertainmentMenuKey) {
        this.openEntertainment(entertainmentMenuKey, item, mainMenu)
        return true
      }

      const url = this.buildUrl(item)
      if (url) {
        window.open(url, '_blank')
        return true
      }

      return false
    },
    resolveEntertainmentMenuKey (item) {
      const menuKey = trimValue(item.token)
      if (ENTERTAINMENT_MENU_KEYS.indexOf(menuKey) > -1) {
        return menuKey
      }

      const link = trimValue(item.link).toLowerCase()
      const matched = ENTERTAINMENT_LINK_MENU_MAP.find(config => {
        return config.keywords.some(keyword => link.indexOf(keyword) > -1)
      })
      return matched ? matched.menu : ''
    },
    async openEntertainment (menuKey, item, mainMenu) {
      const newWindow = window.open('about:blank', '_blank')
      if (!newWindow) {
        this.showError('Popup was blocked')
        return
      }

      try {
        const user = this.getUserId()
        if (!user || !user.key) {
          newWindow.close()
          return
        }

        const fabMainKey = mainMenu && mainMenu.key ? mainMenu.key : ''
        const fabSubmenuKey = fabMainKey && item && item.key && item.key !== fabMainKey ? item.key : ''

        const res = await axios({
          method: 'post',
          url: ENTERTAINMENT_ENDPOINT,
          data: {
            userkey: user.key,
            token: Math.random().toString(36).substring(2, 15),
            menu: menuKey,
            fabMainKey,
            fabSubmenuKey
          },
          headers: {
            'x-api-key': ENTERTAINMENT_API_KEY,
            'Content-Type': 'application/json'
          }
        })

        if (res.data && res.data.status) {
          if (res.data.method === 'POST' && res.data.data && res.data.fields) {
            this.submitPostToWindow(newWindow, res.data.data, res.data.fields)
            return
          }

          if (res.data.data) {
            newWindow.location.href = this.replaceEntertainmentDomains(res.data.data)
            return
          }
        }

        newWindow.close()
        this.showError((res.data && res.data.message) || this.$t('error'))
      } catch (err) {
        newWindow.close()
        console.log(err)
        this.showError(this.$t('error'))
      }
    },
    submitPostToWindow (targetWindow, action, fields) {
      const targetDocument = targetWindow.document
      targetDocument.body.innerHTML = ''

      const form = targetDocument.createElement('form')
      form.method = 'POST'
      form.action = action

      Object.keys(fields).forEach((key) => {
        const input = targetDocument.createElement('input')
        input.type = 'hidden'
        input.name = key
        input.value = fields[key]
        form.appendChild(input)
      })

      targetDocument.body.appendChild(form)
      form.submit()
    },
    replaceEntertainmentDomains (url) {
      return Object.keys(ENTERTAINMENT_DOMAIN_REPLACEMENTS).reduce((result, placeholder) => {
        return result.split(placeholder).join(ENTERTAINMENT_DOMAIN_REPLACEMENTS[placeholder])
      }, url)
    },
    getUserId () {
      const user = localStorage.getItem('userData')
      if (user) {
        return JSON.parse(user)
      }

      firebase.auth().signOut()
      localStorage.removeItem('userData')
      router.replace('/login')
      return null
    },
    getStoredUser () {
      try {
        const user = localStorage.getItem('userData')
        return user ? JSON.parse(user) : null
      } catch {
        return null
      }
    },
    currentMonthRange () {
      const month = moment().tz('Asia/Bangkok')
      return {
        start: month.clone().startOf('month').format('YYYY-MM-DD'),
        end: month.clone().endOf('month').format('YYYY-MM-DD')
      }
    },
    getMaxDepositRequirement (menus) {
      return menus.reduce((max, menu) => {
        const condition = normaliseDepositCondition(menu && menu.depositCondition)
        if (!condition.enabled) return max
        return Math.max(max, condition.minimumCurrentMonthDeposit)
      }, 0)
    },
    getCurrentMonthDepositStart () {
      return moment().tz('Asia/Bangkok').startOf('month')
    },
    async loadCurrentMonthKrungsriDeposit (userKey) {
      const start = this.getCurrentMonthDepositStart()
      const end = moment().tz('Asia/Bangkok')

      if (start.isAfter(end)) return 0

      let total = 0
      const snapshot = await firebase.firestore()
        .collection('krungsri')
        .where('status', '==', 'ดำเนินการแล้ว')
        .where('userkey', '==', userKey)
        .where('createdate', '>=', start.format('YYYY-MM-DD HH:mm:ss'))
        .where('createdate', '<=', end.format('YYYY-MM-DD HH:mm:ss'))
        .orderBy('createdate', 'desc')
        .get()

      snapshot.forEach((doc) => {
        const data = doc.data()
        if (data.type === 'ฝาก') {
          total += amountValue(data.qty, 0)
        }
      })

      return total
    },
    async loadCurrentMonthDeposit (requiredDeposit = 0) {
      const user = this.getStoredUser()
      if (!user || !user.key) {
        this.currentMonthDeposit = 0
        return 0
      }

      const range = this.currentMonthRange()
      let total = 0

      try {
        const snapshot = await firebase.firestore()
          .collection('daily_deposit')
          .where('userkey', '==', user.key)
          .where('createdate', '>=', range.start)
          .where('createdate', '<=', range.end)
          .orderBy('createdate', 'desc')
          .get()

        snapshot.forEach((doc) => {
          const data = doc.data()

          total += amountValue(data.total, 0)
        })

        if (requiredDeposit > 0 && total < requiredDeposit) {
          const krungsriTotal = await this.loadCurrentMonthKrungsriDeposit(user.key)
          total = Math.max(total, krungsriTotal)
        }
      } catch (error) {
        console.error('Error loading current month FAB deposit:', error)
      }

      this.currentMonthDeposit = total
      return total
    },
    showError (message) {
      if (this.$swal) {
        this.$swal({
          icon: 'error',
          title: this.$t('error'),
          text: message
        })
      }
    },
    showWarning (message, title) {
      if (this.$swal) {
        this.$swal({
          icon: 'warning',
          title,
          text: message
        })
      }
    },
    canAccessMainMenu (menu) {
      const condition = normaliseDepositCondition(menu && menu.depositCondition)
      if (!condition.enabled || condition.minimumCurrentMonthDeposit <= 0) return true
      return this.currentMonthDeposit >= condition.minimumCurrentMonthDeposit
    },
    showDepositWarning (menu) {
      const condition = normaliseDepositCondition(menu && menu.depositCondition)
      const menuName = this.getItemName(menu)
      const required = formatAmount(condition.minimumCurrentMonthDeposit)
      const current = formatAmount(this.currentMonthDeposit)
      const message = menuName
        ? `${menuName} ต้องมียอดฝากเดือนนี้ขั้นต่ำ ${required} บาท ยอดฝากเดือนนี้ของคุณคือ ${current} บาท`
        : `ต้องมียอดฝากเดือนนี้ขั้นต่ำ ${required} บาท ยอดฝากเดือนนี้ของคุณคือ ${current} บาท`

      this.showWarning(message, 'ยอดฝากไม่ถึงเงื่อนไข')
    },
    buildUrl (item) {
      const link = this.normalizeLink(trimValue(item.link))
      const token = trimValue(item.token)

      if (!link) return ''
      if (!token) return link
      if (link.indexOf('{token}') > -1) {
        return link.split('{token}').join(encodeURIComponent(token))
      }

      try {
        const url = new URL(link, window.location.origin)
        if (!url.searchParams.get('token')) {
          url.searchParams.set('token', token)
        }
        return url.toString()
      } catch {
        const separator = link.indexOf('?') > -1 ? '&' : '?'
        return link + separator + 'token=' + encodeURIComponent(token)
      }
    },
    normalizeLink (link) {
      if (!link) return ''
      if (/^(https?:|mailto:|tel:|#|\/)/i.test(link)) return link
      if (link.indexOf('//') === 0) return 'https:' + link
      if (/^[a-z0-9.-]+\.[a-z]{2,}([/:?#].*)?$/i.test(link)) return 'https://' + link
      return link
    },
    getItemName (item) {
      const locale = this.$i18n ? this.$i18n.locale : 'th'
      if (locale === 'en' && item.name_en) return item.name_en
      if ((locale === 'my' || locale === 'mm') && item.name_my) return item.name_my
      return item.name_th || item.name_en || item.name_my || ''
    },
    shouldShowSubmenu (submenu) {
      return submenu.status === ACTIVE_STATUS
    },
    normaliseSubmenus (rawSubmenus) {
      const source = rawSubmenus || {}
      const submenus = Object.keys(source).map((key, index) => {
        const item = source[key] || {}
        return {
          key,
          name_th: textValue(item.name_th),
          name_en: textValue(item.name_en),
          name_my: textValue(item.name_my),
          icon: textValue(item.icon),
          link: textValue(item.link),
          token: textValue(item.token),
          order: numberValue(item.order, index + 1),
          status: textValue(item.status || ACTIVE_STATUS)
        }
      })

      return submenus
        .filter(submenu => this.shouldShowSubmenu(submenu))
        .sort((a, b) => a.order - b.order)
    },
    normaliseMainMenu (key, value, index) {
      const item = value || {}

      return {
        key,
        name_th: textValue(item.name_th),
        name_en: textValue(item.name_en),
        name_my: textValue(item.name_my),
        icon: textValue(item.icon),
        link: textValue(item.link),
        token: textValue(item.token),
        order: numberValue(item.order, index + 1),
        status: textValue(item.status || ACTIVE_STATUS),
        depositCondition: normaliseDepositCondition(item.depositCondition),
        submenus: this.normaliseSubmenus(item.submenus)
      }
    },
    shouldShowMainMenu (menu) {
      return Boolean(menu.icon || menu.link || menu.submenus.length)
    },
    async fetchFabMenu () {
      try {
        const data = await getSessionCachedData(`fab-menu-${this.statusFilter}`, async () => {
          const snapshot = await firebase.database()
            .ref('/fab_menu')
            .orderByChild('status')
            .equalTo(this.statusFilter)
            .once('value')
          return snapshot.val() || {}
        })
        const menus = Object.keys(data).map((key, index) => this.normaliseMainMenu(key, data[key], index))
        const visibleMenus = menus
          .filter(menu => this.shouldShowMainMenu(menu))
          .sort((a, b) => a.order - b.order)
        const maxRequiredDeposit = this.getMaxDepositRequirement(visibleMenus)

        await this.loadCurrentMonthDeposit(maxRequiredDeposit)

        this.fabMenuItems = visibleMenus
      } catch {
        this.fabMenuItems = []
      }
    }
  }
}
</script>

<template>
  <div v-if="fabMenuItems.length" class="fab-suite">
    <button
      v-if="activeMain"
      class="fab-overlay"
      type="button"
      aria-label="Close FAB menu"
      @click="closeMenu"
    />

    <div class="fab-main-row">
      <div
        v-for="menu in fabMenuItems"
        :key="menu.key"
        class="fab-main-slot"
      >
        <transition-group
          v-if="activeMainKey === menu.key && menu.submenus.length"
          name="fab-submenu"
          tag="div"
          class="fab-submenu-stack"
        >
          <button
            v-for="(submenu, index) in menu.submenus"
            :key="submenu.key"
            type="button"
            class="fab-submenu-button"
            :title="getItemName(submenu)"
            :style="{ transitionDelay: (index * 0.04) + 's' }"
            @click.stop="openSubmenu(submenu)"
          >
            <span class="fab-submenu-label">{{ getItemName(submenu) }}</span>
            <span class="fab-submenu-icon">
              <img
                v-if="submenu.icon"
                class="fab-submenu-image"
                :src="submenu.icon"
                :alt="getItemName(submenu)"
              >
              <span v-else class="fab-fallback">{{ getItemName(submenu).charAt(0) }}</span>
            </span>
          </button>
        </transition-group>

        <button
          type="button"
          class="fab-main-button"
          :class="{ 'is-active': activeMainKey === menu.key }"
          :title="getItemName(menu)"
          @click.stop="toggleMainMenu(menu)"
        >
          <img
            v-if="menu.icon"
            class="fab-main-image"
            :src="menu.icon"
            :alt="getItemName(menu)"
          >
          <span v-else class="fab-fallback main">{{ getItemName(menu).charAt(0) }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.fab-suite {
  position: fixed;
  right: 16px;
  bottom: calc(68px + env(safe-area-inset-bottom));
  z-index: 1001;
  pointer-events: none;
}

.fab-overlay {
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100vh;
  padding: 0;
  border: 0;
  background: transparent;
  pointer-events: auto;
}

.fab-main-row {
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 10px;
  pointer-events: auto;
}

.fab-main-slot {
  position: relative;
  flex: 0 0 72px;
  width: 72px;
  height: 72px;
  pointer-events: auto;
}

.fab-main-button,
.fab-submenu-button {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: transparent;
  outline: none;
  -webkit-tap-highlight-color: transparent;
}

.fab-main-button {
  filter: drop-shadow(0 8px 14px rgba(0, 0, 0, .32));
  transition: transform .18s ease, filter .18s ease;
}

.fab-main-button:hover,
.fab-main-button.is-active {
  transform: translateY(-3px) scale(1.04);
  filter: drop-shadow(0 10px 18px rgba(160, 56, 255, .44));
}

.fab-main-button:active,
.fab-submenu-button:active {
  transform: scale(.94);
}

.fab-main-image,
.fab-submenu-image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  user-select: none;
  pointer-events: none;
}

.fab-main-image,
.fab-fallback.main {
  animation: fab-main-pulse 1.8s ease-in-out infinite;
  transform-origin: center;
}

.fab-submenu-stack {
  position: absolute;
  right: 0;
  bottom: calc(100% + 8px);
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 7px;
  pointer-events: auto;
}

.fab-submenu-button {
  justify-content: flex-end;
  gap: 8px;
  width: auto;
  height: 62px;
  border-radius: 0;
  filter: drop-shadow(0 7px 12px rgba(0, 0, 0, .3));
  transition: transform .18s ease, filter .18s ease, opacity .18s ease;
}

.fab-submenu-button:hover {
  transform: translateY(-2px) scale(1.06);
  filter: drop-shadow(0 10px 16px rgba(160, 56, 255, .44));
}

.fab-submenu-label {
  display: block;
  max-width: 170px;
  padding: 7px 12px;
  overflow: hidden;
  border: 1px solid rgba(255, 232, 84, .95);
  border-radius: 999px;
  background: linear-gradient(180deg, #fff37a 0%, #ffd52e 100%);
  box-shadow: 0 6px 16px rgba(0, 0, 0, .25), inset 0 1px 0 rgba(255, 255, 255, .7);
  color: #4b1669;
  font-size: 13px;
  font-weight: 700;
  line-height: 1.25;
  text-align: right;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fab-submenu-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 62px;
  width: 62px;
  height: 62px;
}

.fab-fallback {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  color: #fff;
  font-size: 22px;
  font-weight: 800;
  background: radial-gradient(circle at 35% 25%, #ff7cff 0, #9138ff 58%, #4a0dbb 100%);
  box-shadow: inset 0 0 0 3px rgba(255, 255, 255, .55);
}

.fab-fallback.main {
  font-size: 26px;
}

.fab-submenu-enter-active,
.fab-submenu-leave-active {
  transition: opacity .2s ease, transform .2s ease;
}

.fab-submenu-enter,
.fab-submenu-leave-to {
  opacity: 0;
  transform: translateY(14px) scale(.78);
}

@keyframes fab-main-pulse {
  0%,
  100% {
    transform: scale(1);
    filter: drop-shadow(0 0 0 rgba(255, 225, 86, 0));
  }

  50% {
    transform: scale(1.08);
    filter: drop-shadow(0 0 12px rgba(255, 225, 86, .7));
  }
}

@media (min-width: 769px) {
  .fab-suite {
    right: 24px;
  }
}

@media (max-width: 768px) {
  .fab-suite {
    right: 10px;
    bottom: calc(68px + env(safe-area-inset-bottom));
  }

  .fab-main-row {
    gap: 8px;
  }

  .fab-main-slot {
    flex-basis: 66px;
    width: 66px;
    height: 66px;
  }

  .fab-submenu-button {
    height: 58px;
  }

  .fab-submenu-icon {
    flex-basis: 58px;
    width: 58px;
    height: 58px;
  }

  .fab-submenu-label {
    max-width: 138px;
    padding: 6px 10px;
    font-size: 12px;
  }
}

@media (max-width: 360px) {
  .fab-main-row {
    gap: 6px;
  }

  .fab-main-slot {
    flex-basis: 60px;
    width: 60px;
    height: 60px;
  }

  .fab-submenu-button {
    height: 54px;
  }

  .fab-submenu-icon {
    flex-basis: 54px;
    width: 54px;
    height: 54px;
  }

  .fab-submenu-label {
    max-width: 116px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .fab-main-image,
  .fab-fallback.main {
    animation: none;
  }
}
</style>
